<template>
  <div class="header">
    <div class="centerBar">
      <div
        class="item"
        v-for="(item, index) in navList"
        :class="index === granaryIndex ? 'active' : ''"
        :key="item.name"
        @click="onClick(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="rightBar">
      <span class="date">{{ nowDate1 }}</span>
      <span class="week">{{ DateToday }}</span>
      <span class="time num">{{ nowTime }}</span>
      <div>
        <span class="flex cursor">
          <img width="20px" :src="form.code" />
          <span>{{ form.sk_s }}</span>
          <span>{{ form.sk_t }}°C</span>
        </span>
      </div>
      <a
        class="yyzx"
        :href="yyurl"
        title="茂名市荔枝优势产区产业园荔枝产业大数据中心"
      >
        <img src="~images/index/home/yyxt.png" alt="" />
        <p>应用中心</p>
      </a>
    </div>
    <a class="click-area" @click="goHome"></a>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getCodeByJwd } from "@/api/home";
export default {
  computed: {
    ...mapGetters(["qxzInfo", "granaryIndex"]),
    yyurl() {
      if (process.env.NODE_ENV === "prod1") {
        return "/mm/m-screen/zt/zlcy/ywtg/index.html";
      } else if (this.clientid === "20008") {
        return window.__config.VUE_APP_IMG_URL + "/ywtg";
      } else {
        return "http://36.133.180.35:8081/";
      }
    },
  },
  data() {
    return {
      DateToday: "",
      nowTime: this.$formatDate(new Date(), "hh:mm:ss"),
      nowDate1: this.$formatDate(new Date(), "yyyy-MM-dd"),
      weekData: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      animate: false,
      scrollTimer: null,
      form: {},
      navList: [
        {
          name: "总览",
          path: "/granary",
        },
        {
          name: "种植业",
          path: "/granary/zzy",
        },
        {
          name: "畜牧业",
          path: "/granary/xmy",
        },
        {
          name: "渔业",
          path: "/granary/yy",
        },
        {
          name: "农村",
          path: "/granary/nc",
        },
      ],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.nowTime = this.$formatDate(new Date(), "hh:mm:ss");
    }, 1000);
    let mydate = new Date().getDay();
    this.DateToday = this.weekData[mydate];
    this.dataLoad();
  },
  methods: {
    goHome() {
      this.$router.push("/granary");
    },
    onClick(index) {
      if (this.granaryIndex !== index) {
        // this.$store.dispatch("map/setGranaryIndex", index);
        if (this.navList[index].path) {
          this.$router.push(this.navList[index].path);
        }
      }
    },
    dataLoad() {
      if (JSON.stringify(this.qxzInfo) == "{}") {
        getCodeByJwd({ code: "441700" }).then((res) => {
          if (res.content) {
            this.$store.dispatch("drawer/setQxzInfo", res.content);
            this.form = this.qxzInfo.sk;
            this.form.code = require("images/index/weather/wether/" +
              this.qxzInfo.sk.i);
            this.weatherObj = this.qxzInfo;
            this.dayList = this.weatherObj.f_rows.slice(0, 7);
            this.dayList.map((v) => {
              v.code = require("images/index/weather/wether/" + v.i);
            });
          }
        });
      } else {
        this.form = this.qxzInfo.sk;
        this.form.code = require("images/index/weather/wether/" +
          this.qxzInfo.sk.i);
        this.weatherObj = this.qxzInfo;
        this.dayList = this.weatherObj.f_rows.slice(0, 7);
        this.dayList.map((v) => {
          v.code = require("images/index/weather/wether/" + v.i);
        });
      }
    },
    handleClick() {
      this.$router.push("/index");
      this.$emit("barChoose");
    },
    weatherClick() {
      this.$store.dispatch("drawer/setRightComponent", "weatherDrawer");
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.header
  position absolute
  width 100%
  z-index 7
  height .47rem
  background url('~images/granary/top-bg.png') no-repeat center
  background-size 100% 100%
  .cursor
    cursor pointer

  .rightBar
    display flex
    align-items center
    position absolute
    top .14rem
    // width 340px
    width 450px
    right: 0
    color #fff
    font-size .07rem
    padding-left 5px

    span
      margin 0 5px

    .time
      font-size .12rem

    .yyzx
      display block
      width 64px
      margin-right .1rem
      text-align center
      >img
        width 30px
        margin 0 auto
      >p
        color #fff
        font-size 12px
  .centerBar
    position absolute
    top 0
    // right 320px
    right 430px
    left 650px
    bottom 0
    display flex
    align-items center
    justify-content space-evenly
    .item
        background url('~images/granary/nav.png') no-repeat left center
        background-size 100% 100%
        width 104px
        height 38px
        display flex
        align-items center
        justify-content center
        color #45C3F2
        font-weight 600
        font-size 14px
        cursor pointer
    .item.active
        background url('~images/granary/nav-active.png') no-repeat left center
        background-size 100% 100%
        color #F2BA41
  .click-area
    position absolute
    left 0
    top 0
    width 31%
    height 100%
    display block
    opacity 0
    cursor pointer
</style>
